module.exports = __webpack_public_path__ + "img/img_back_navyblue.e142d8f0.png";